/* -------------------------------------------------------------------------- */
/*                                Switch styles                               */
/* -------------------------------------------------------------------------- */

@import './bq-switch.variables';

:host {
  @apply inline-block;
}

:host(.full-width) {
  @apply is-full;
}

.bq-switch {
  @apply flex cursor-pointer select-none items-center rounded-s transition-colors duration-300 p-b-2 p-i-2;

  justify-content: var(--bq-switch--justify-content);

  // Display background on hover (if enabled)
  &.has-background:not(.is-disabled):hover {
    @apply bg-hover-ui-primary;
  }

  &.is-disabled {
    @apply cursor-not-allowed opacity-60;
  }
}

.bq-switch--input:not(:disabled):focus,
.bq-switch--input:not(:disabled):focus-visible {
  ~ .bq-switch--control {
    @apply focus;
  }
}

.bq-switch--control__dot {
  @apply absolute start-xs2 rounded-full bg-ui-primary bs-[--bq-switch--dot-size] is-[--bq-switch--dot-size];
  @apply group-[&.is-checked]:start-[calc(100%_-_var(--bq-switch--dot-size)_-_var(--bq-spacing-xs2))] group-[&.is-checked]:bg-[--bq-icon--alt];
  @apply transition-all duration-300;
}

.bq-switch--control__icon {
  --bq-icon--size: var(--bq-switch--dot-size) !important;

  &::part(base) {
    @apply flex;
  }
}
